import { parseISO } from 'date-fns';
import { ISODateString } from 'utils/eventTimes.js';

function prepareBody(info) {
  const result = { ...info };
  const { birthDate, administrativeGroupId } = info;
  if (birthDate) {
    result.birthDate = ISODateString(typeof birthDate === 'string' ? parseISO(birthDate) : birthDate);
  }
  if (!administrativeGroupId) {
    delete result.administrativeGroupId;
  }
  return result;
}

export default prepareBody;
